import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SwitchAppService } from 'src/app/switch-app.service';
import { environment } from 'src/environments/environment';
import { AppType } from 'src/environments/environmentTypes';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.css'],
})
export class AuthorizeComponent implements OnInit {
  clientId: string;
  pageId: string;
  params: any;

  get applications(): {
    clientId: string;
    domain: string;
    logo: string;
    title: string;
    pageTitle: string;
    type: AppType;
  }[] {
    const result: any[] = [];
    for (const clientId of Object.keys(environment.apps)) {
      const app = environment.apps[clientId];
      app.clientId = clientId;
      result.push(app);
    }
    return result;
  }

  constructor(
    ac: ActivatedRoute,
    private resolve: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    private switchApp: SwitchAppService
  ) {
    ac.queryParams.subscribe((params) => {
      this.params = params;
      const states = this.parseState(params);
      if (!states) {
        // alert('inavlid');
        return;
      }
    });
    const app = this.applications.find((e) => e.clientId === this.clientId);
    if (app) {
      this.switchApp.setComponent(
        this.clientId,
        app.type,
        viewContainerRef,
        resolve,
        'authorize'
      );
    }
  }

  private parseState(params: {
    client_id?: string;
    state?: string;
    nonce?: string;
    response_type?: string;
    scope?: string;
    redirect_uri?: string;
  }) {
    if (!params.client_id) return undefined;
    this.clientId = params.client_id;
    if (!params.response_type) return undefined;
    const state: string = params.state;
    if (!state) {
      return undefined;
    }
    const splittedState = state.split(':');
    if (splittedState.length < 1) {
      return undefined;
    }

    if (splittedState.length == 2) {
      this.pageId = splittedState[0];
    }

    return {
      // attributes: attributes,
      state: splittedState[1],
    };
  }

  get isStation(): boolean {
    return /dstation/g.test(
      this.applications.find((app) => app.clientId === this.clientId).type
    );
  }

  ngOnInit(): void {}
}
